var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUserIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#userIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.82 8.274-1.982-.787a4.105 4.105 0 0 1-5.68-.003l-1.98.792A1.875 1.875 0 0 0 0 10.016v1.609c0 .207.168.375.375.375h11.25a.375.375 0 0 0 .375-.375v-1.61a1.866 1.866 0 0 0-1.18-1.74ZM9.376 10.5H7.5a.375.375 0 0 1 0-.75h1.875a.375.375 0 0 1 0 .75Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.136.59a8.662 8.662 0 0 0-6.272 0 .375.375 0 0 0-.239.35V4.5a3.375 3.375 0 1 0 6.75 0V.94a.375.375 0 0 0-.239-.35ZM8.626 4.5c0 .252-.037.504-.11.745A5.55 5.55 0 0 0 6 4.5a5.55 5.55 0 0 0-2.515.745 2.601 2.601 0 0 1-.11-.745V3.459a7.9 7.9 0 0 1 5.25 0V4.5ZM6 7.125a2.623 2.623 0 0 1-2.2-1.197A4.95 4.95 0 0 1 6 5.25a4.95 4.95 0 0 1 2.2.678A2.623 2.623 0 0 1 6 7.125Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "userIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
})))));
export default SvgUserIcon;